// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 72 72"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 41C25.0685 41 36 30.0685 36 11 36 30.0685 46.9315 41 66 41 46.9315 41 36 51.9315 36 71 36 51.9315 25.0685 41 6 41ZM0 12C7.62742 12 12 7.62742 12 0 12 7.62742 16.3726 12 24 12 16.3726 12 12 16.3726 12 24 12 16.3726 7.62742 12 0 12ZM55 19C60.0849 19 63 16.0849 63 11 63 16.0849 65.9151 19 71 19 65.9151 19 63 21.9151 63 27 63 21.9151 60.0849 19 55 19Z"
      clipRule="evenodd"
    />
  </svg>
);
const IconStarsSolid = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconStarsSolid;
